import { useMemo, useState } from "react";
import {
  Bar,
  BarChart,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import Colors from "../../constants/Colors";
import utils from "../../helpers/utils";
import { ChartData } from "../../types";

interface ChartProps {
  data?: ChartData[];
  sliceNum?: number;
  sufix?: string;
}

function Chart({ data = [], sliceNum = -6, sufix = "" }: ChartProps) {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const chartData = useMemo(() => {
    return utils
      .addArray(data, { count: 0, date: "N/A" })
      .slice(sliceNum)
      .map((ds: ChartData) => ({
        date: ds.date,
        count: Number.isFinite(ds.count) ? ds.count : 0,
      }));
  }, [data, sliceNum]);

  const lastIndex = chartData.length - 1;

  return (
    <div className="w-full h-[170px] select-none">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={chartData}
          margin={{ top: 16, right: 8, left: 0, bottom: 0 }}
          onMouseLeave={() => setActiveIndex(null)}
        >
          <XAxis
            dataKey="date"
            tick={{ fill: "rgba(15,23,42,0.72)", fontSize: 11 }}
            axisLine={{ stroke: "rgba(15,23,42,0.12)" }}
            tickLine={false}
            interval={0}
          />
          <YAxis
            tick={{ fill: "rgba(15,23,42,0.55)", fontSize: 11 }}
            axisLine={false}
            tickLine={false}
            width={26}
          />
          <Tooltip
            cursor={{ fill: "rgba(15,23,42,0.06)" }}
            contentStyle={{
              background: "rgba(255,255,255,0.98)",
              border: "1px solid rgba(15,23,42,0.14)",
              borderRadius: 12,
              color: "var(--ef-text)",
            }}
            labelStyle={{ color: "rgba(15,23,42,0.75)" }}
            formatter={(value: unknown) => {
              if (typeof value === "number") return `${value}${sufix}`;
              return `${String(value)}${sufix}`;
            }}
          />
          <Bar
            dataKey="count"
            radius={[12, 12, 12, 12]}
            onClick={(_payload: unknown, index: number) =>
              setActiveIndex(index)
            }
            onMouseMove={(_payload: unknown, index: number) =>
              setActiveIndex(index)
            }
          >
            {chartData.map((entry, index) => {
              const isActive = index === activeIndex;
              const isLast = index === lastIndex;

              return (
                <Cell
                  key={`cell-${entry.date}-${entry.count}`}
                  fill={
                    isActive || isLast
                      ? Colors.background2
                      : "rgba(98,83,212,0.28)"
                  }
                />
              );
            })}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default Chart;
